// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".navbar__button__link[data-v-558c7b10]{background:none;border:none;outline:none;cursor:pointer}", ""]);
// Exports
module.exports = exports;
